import { Destination } from "../models/destination";
import { JobMode } from "../models/job.mode";
import { DifferentLocation as LocationAddress, Location } from "../models/location";
import { DESTINATION, ITEM_DESTINATION_COLOR } from "./enums";

type GetValueFromEachDestinationProps = {
  destination?: Destination;
  destinationResidence?: Location;
  modeDestination?: JobMode;
};

const getLongAddressDestination = (customerLocations?: LocationAddress[]) => {
  const locationsDelivery: Destination[] = [];
  const locations = customerLocations;

  if (!locations) return locationsDelivery;

  locations.forEach((addressObject: LocationAddress) => {
    if (typeof addressObject.id === "string") {
      if (!addressObject.id.includes("delete"))
        locationsDelivery.push({
          id: undefined,
          name: `Residence: ${addressObject?.longAddress || "TBA"}`,
          destinationResidenceId: addressObject?.id,
          color: ITEM_DESTINATION_COLOR.Residence,
        });
    } else {
      locationsDelivery.push({
        id: undefined,
        name: `Residence: ${addressObject?.longAddress || "TBA"}`,
        destinationResidenceId: addressObject?.id,
        color: ITEM_DESTINATION_COLOR.Residence,
      });
    }
  });

  return locationsDelivery;
};

const getModeIsDestinations = (modes?: JobMode[]): JobMode[] => {
  if (!modes || modes?.length === 0) return [];

  const modeDestinations: JobMode[] = [];

  for (const mode of modes) {
    if (mode?.isDestination) {
      modeDestinations.push(mode);
    }
  }

  return modeDestinations;
};

const mapOrder = (array: Array<Destination>, order: Array<string>) => {
  array.sort((valueA, valueB) => {
    return order.indexOf(valueB?.name) > order.indexOf(valueA?.name) ? 1 : -1;
  });

  return array;
};

export const getValueFromEachDestination = (
  destinationValue: Destination | undefined,
  locations?: LocationAddress[]
): GetValueFromEachDestinationProps | undefined => {
  let destination;
  let destinationResidence;
  let modeDestination;

  if (!destinationValue)
    return {
      destination,
      destinationResidence,
      modeDestination,
    };

  if (
    destinationValue?.id &&
    !destinationValue?.destinationResidenceId &&
    !destinationValue?.isDestination
  ) {
    destination = destinationValue;
    destinationResidence = undefined;
    modeDestination = undefined;

    return {
      destination,
      destinationResidence,
      modeDestination,
    };
  }

  if (
    !destinationValue?.id &&
    destinationValue?.destinationResidenceId &&
    !destinationValue?.isDestination &&
    locations
  ) {
    destinationResidence = locations.find(
      (location) => location?.id === destinationValue?.destinationResidenceId
    ) as Location;
    destination = undefined;
    modeDestination = undefined;

    return {
      destination,
      destinationResidence,
      modeDestination,
    };
  }

  if (
    destinationValue?.id &&
    !destinationValue?.destinationResidenceId &&
    destinationValue?.isDestination
  ) {
    destination = undefined;
    destinationResidence = undefined;
    modeDestination = destinationValue as JobMode;

    return {
      destination,
      destinationResidence,
      modeDestination,
    };
  }
};

export const getDestinations = (
  customDestinations: Destination[],
  customerLocations?: LocationAddress[],
  modes?: JobMode[]
) => {
  const destinations: Destination[] = [];
  const longAddressDestination = getLongAddressDestination(customerLocations);
  const modeDestinations = getModeIsDestinations(modes);

  if (customDestinations && customDestinations?.length > 0) {
    mapOrder(
      customDestinations,
      [
        DESTINATION.AIR,
        DESTINATION.SEA,
        DESTINATION.ROAD,
        DESTINATION.STORE,
        DESTINATION.OPTIONAL,
        DESTINATION.NOT_GOING,
      ].reverse()
    )?.forEach((customDestination) => {
      destinations.push(customDestination);
    });
  }

  return [...longAddressDestination, ...destinations, ...modeDestinations];
};
